import { getBrand } from "@faire/help-center-utils/serialized-data/getBrand";

export const isBrandInactive = (): boolean => {
  const brand = getBrand();
  return !brand?.active;
};
